import type { SxProps, Theme } from '@mui/material/styles';

const BORDER = '1px solid #e2e8f0';

/** Основная кнопка вкладок мат. отчета: без тени, как в остальной отчетности */
export const PRIMARY_BUTTON_SX: SxProps<Theme> = {
  textTransform: 'none',
  fontWeight: 600,
  borderRadius: '8px',
  boxShadow: 'none',
  whiteSpace: 'nowrap',
  '&:hover': { boxShadow: 'none' }
};

/**
 * Небольшие списки (изменения, поля): нативная таблица, стили заданы один раз на контейнере
 * вложенными селекторами. Кнопки действий - `button.act` (`ok`, `danger`, `icon`), метка - `span.tag`.
 */
export const LIST_TABLE_SX: SxProps<Theme> = {
  overflowX: 'auto',
  '& table': { width: '100%', borderCollapse: 'separate', borderSpacing: 0 },

  '& th': {
    padding: '10px 16px',
    backgroundColor: '#f8fafc',
    color: '#475569',
    fontFamily: 'inherit',
    fontSize: '0.8rem',
    fontWeight: 700,
    textAlign: 'left',
    borderBottom: BORDER,
    whiteSpace: 'nowrap'
  },
  '& th.narrow': { width: 72 },
  '& th.actions': { width: 160 },
  '& th.right, & td.right': { textAlign: 'right' },
  '& th.center, & td.center': { textAlign: 'center' },

  '& tbody tr': { backgroundColor: '#ffffff' },
  '& tbody tr:hover': { backgroundColor: '#f8fafc' },
  '& tbody tr:last-of-type td': { borderBottom: 'none' },

  '& td': {
    padding: '8px 16px',
    borderBottom: '1px solid #f1f5f9',
    fontFamily: 'inherit',
    fontSize: '0.85rem',
    color: '#1e293b'
  },
  '& td.muted': { color: '#64748b' },
  '& td.strong': { fontWeight: 600 },
  '& td.nowrap': { whiteSpace: 'nowrap' },

  '& code': {
    padding: '1px 6px',
    borderRadius: '4px',
    backgroundColor: '#f1f5f9',
    fontFamily: 'Consolas, "Courier New", monospace',
    fontSize: '0.82rem'
  },

  '& span.tag': {
    display: 'inline-block',
    padding: '1px 10px',
    borderRadius: '10px',
    backgroundColor: '#f1f5f9',
    color: '#64748b',
    fontSize: '0.78rem',
    fontWeight: 600
  },
  '& span.tag.on': { backgroundColor: '#ecfdf5', color: '#059669' },

  '& button.act': {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    height: 30,
    padding: '0 12px',
    border: '1px solid #cbd5e1',
    borderRadius: '6px',
    backgroundColor: '#ffffff',
    color: '#475569',
    fontFamily: 'inherit',
    fontSize: '0.8rem',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    cursor: 'pointer'
  },
  '& button.act + button.act': { marginLeft: '8px' },
  '& button.act.icon': { width: 32, padding: 0 },
  '& button.act svg': { fontSize: 17 },
  '& button.act:hover:not(:disabled)': { backgroundColor: '#f8fafc', borderColor: '#94a3b8' },
  '& button.act:disabled': { cursor: 'default', opacity: 0.6 },
  '& button.act.ok': { borderColor: '#10b981', color: '#059669' },
  '& button.act.ok:hover:not(:disabled)': { backgroundColor: '#ecfdf5', borderColor: '#059669' },
  '& button.act.danger': { borderColor: '#fca5a5', color: '#dc2626' },
  '& button.act.danger:hover:not(:disabled)': { backgroundColor: '#fef2f2', borderColor: '#f87171' }
};
